module.exports = __webpack_public_path__ + "static/media/mars.17391abb.png";